import React from 'react';
import { CloudRain } from 'lucide-react';

export type InstallWeatherRainIconProps = {
  /** Native tooltip / hover text */
  title?: string;
  className?: string;
  size?: number;
};

const InstallWeatherRainIcon: React.FC<InstallWeatherRainIconProps> = ({
  title,
  className = '',
  size = 12,
}) => (
  <span
    className={`install-weather-rain-icon ${className}`.trim()}
    title={title}
    aria-label={title ?? 'Rain in forecast'}
    role="img"
  >
    <CloudRain size={size} aria-hidden strokeWidth={2.25} />
  </span>
);

export default InstallWeatherRainIcon;
